import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { post, del } from '../../api/axios_call';
import './Model.css';
import { cloudImg } from '../../general';

const Crop = ({ image, setCropPar, id }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const makeCrop = () => {
    post(`image/${id}`, croppedAreaPixels).then(() => {
      setCropPar(false);
      window.location.reload();
    });
  };
  const onCropComplete = useCallback((cA, cAP) => setCroppedAreaPixels(cAP), []);
  return (
    <>
      <div className="modelpage_model_box">
        <p className="modelpage_model_box_high_res" onClick={makeCrop}>crop</p>
      </div>
      <Cropper
        image={image}
        crop={crop}
        zoom={zoom}
        aspect={140 / 190}
        onCropChange={setCrop}
        onCropComplete={onCropComplete}
        onZoomChange={setZoom}
      />
    </>
  );
};

const DeleteBox = ({ setDelete, id }) => {
  const delDat = () => {
    del('image', id);
    window.location.reload();
  };
  return (
    <div className="DeleteBox">
      <p>Sure you want to delete?</p>
      <p onClick={() => delDat()}>YES</p>
      <p onClick={() => setDelete(false)}>NO</p>
    </div>
  );
};

export default (({ image, slug, viewSize }) => {
  const [crop, setCrop] = useState(false);
  const [showDel, setDelete] = useState(false);
  const makeFront = () => {
    post(`image/${slug}/${image.id}`);
  };
  return (
    <div className="modelpage_model">
      { crop
        ? (
          <Crop
            viewSize={viewSize}
            image={image.high}
            id={image.id}
            setCropPar={setCrop}
            cropPar={crop}
          />
        ) : (
          <>
            {showDel ? <DeleteBox setDelete={setDelete} id={image.id} /> : null}
            <div className="modelpage_model_box">
              <p className="modelpage_model_box_lightbox" onClick={() => setDelete(!showDel)}>delete</p>
              <p className="modelpage_model_box_middel" onClick={() => makeFront()}>make front image</p>
              <p className="modelpage_model_box_high_res" onClick={() => setCrop(true)}>crop</p>
            </div>
            <img
              className="modelpage_model_img"
              src={cloudImg(image.thumb.crop_2)}
              alt={cloudImg(image.thumb.crop_2)}
            />
          </>
        )}
    </div>
  );
});
